<div class="dialog">
    <div class="dialog-header">
        <h2>{{ (data.title || 'shared.dialog.confirm.heading') | translate }}</h2>
    </div>
    <div class="dialog-body">
        <p [innerHTML]="(data.text || 'shared.dialog.confirm.text' | translate) | newlines"></p>

        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" (click)="onConfirm()">{{ 'shared.button.confirm' | translate }}</a>
        </div>
    </div>
</div>

